import Components from './../Component';

export default class Modal extends Components {
  constructor($) {
    super($);
  }

  init(index, element) {
    this.$('[data-modal-launcher=' + this.$(element).attr('id') + ']').on('click', function (e) {
      this.open(index, element);
    }.bind(this));

    this.$('[data-modal-launcher=' + this.$(element).attr('id') + ']').on('keyup', function (e) {
      if (e.keyCode == 13) {
        this.open(index, element);
      }
    }.bind(this));

    this.$(element).find('.close-modal').on('click', function (e) {
      this.close(index, element);
    }.bind(this));

    this.$(element).find('.close-modal').on('keyup', function (e) {
      if (e.keyCode == 13) {
        this.close(index, element);
      }
    }.bind(this));

    this.$('.overlay').on('click', function (e) {
      //console.log(e);
      this.close(index, element);
    }.bind(this));

    this.$(document).keyup(function (e) {
      if (e.keyCode == 27 && this.$(element).hasClass('open')) {
        this.close(index, element);
      }
    }.bind(this));

  }



  open(index, element) {
    this.$(element).addClass('open');
    this.$('body').addClass('modal-open');
    this.$('.overlay').addClass('show');

    setTimeout(function(){
      this.$(element).find('.modal-close-button').focus();
    }.bind(this),200);
  }

  close(index, element) {
    this.$(element).removeClass('open');
    this.$('body').removeClass('modal-open');
    this.$('.overlay').removeClass('show');

    setTimeout(function(){
      this.$('[data-modal-launcher=' + this.$(element).attr('id') + ']').focus();
    }.bind(this), 200);

  }

}